import { formatCurrencyAmount, type MoneyWithOptionalCurrency } from 'noddi-util';
import { MembershipProgramLogo } from 'noddi-web';

type Props = {
  label: string;
  amount: MoneyWithOptionalCurrency;
  imageUrl?: string | null;
};

export const CheckoutDiscountRow = ({ label, amount, imageUrl }: Props) => (
  <div className='flex items-center justify-between gap-4'>
    <span className='flex min-w-0 items-center gap-2'>
      {imageUrl ? <MembershipProgramLogo url={imageUrl} /> : null}
      <span className='truncate'>{label}</span>
    </span>
    <span className='shrink-0'>{formatCurrencyAmount({ money: amount })}</span>
  </div>
);
